import { ReactElement } from 'react';
import { toast } from 'react-toastify';

interface ErrorBoundaryProps {
    children?: ReactElement;
}

const ErrorBoundary = (props: ErrorBoundaryProps): ReactElement => {
    try
    {
        return props.children;
    }
    catch(ex)
    {
        toast(`${ex}`, {autoClose: false });
    }
}

export {ErrorBoundary};
